import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  padding: '3.5rem 1rem 2rem 1rem',
  flexGrow: 1,
}));

export const MainTitle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.75rem',
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '2.5rem',
  justifyContent: 'flex-start',
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '1rem',

  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
}));

export const AlignStatusAndProof = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0rem',
  [theme.breakpoints.up('sm')]: {
    gap: '1rem',
  },
}));

export const MobileProofButton = styled('div')(({ theme }) => ({
  position: 'fixed',
  right: '1rem',
  bottom: '3.2rem',
}));

export const AlignMobileButton = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  position: 'fixed',
  right: '1rem',
  bottom: '3.2rem',
  zIndex: '999',
}));

export const StatusBadge = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.orange.main,
  textAlign: 'center',
  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.primary.dark,
  width: '8rem',
  height: '1.625rem',
  borderRadius: '1rem',
  padding: '0.2rem 0.5rem',
  marginLeft: 'auto',
}));
